/**
 * Browser locale used for read-only number/date display, fixed for the whole session.
 * The in-app language picker changes texts only — display formats deliberately follow
 * the browser so numeric/date conventions don't change when the UI language does.
 */
export const displayLocale: string = (typeof navigator !== 'undefined' && navigator.language) || 'en';

/**
 * Base options for USD amounts formatted through `i18n.number` (which uses `displayLocale`).
 * `narrowSymbol` keeps a plain "$" — the default symbol is "US$" for en-GB/en-CA and "$US" for fr.
 * Crypto users expect "$" regardless of locale: balances are stablecoin-denominated, not fiat USD.
 */
export const USD_CURRENCY_FORMAT = {
  style: 'currency',
  currency: 'USD',
  currencyDisplay: 'narrowSymbol',
} as const satisfies Intl.NumberFormatOptions;
